// Import necessary modules
import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import InfoIcon from '@mui/icons-material/Info';
import Header from "../Homepage/Components/Header"

const TermsAndPolicies = () => {
  return (
    <Box>
        <Header/>
        <Box
    sx={{
      padding: "32px",
      maxWidth: "900px",
      margin: "32px auto", // Added margin-top of 32px
      backgroundColor: "#f4f6f8",
      borderRadius: "16px",
      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
    }}
  >
    
      <Typography
        variant="h4"
        sx={{
          fontWeight: "bold",
          fontFamily: "'Work Sans', sans-serif",
          textAlign: "center",
          marginBottom: "24px",
          color: "#333",
        }}
      >
        Stok101 Terms of Use & Policies
      </Typography>

      {/* Section 1: License & Access */}
      <Box sx={{ marginBottom: "24px" }}>
        <Typography
          variant="h6"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            fontWeight: "bold",
            fontFamily: "'Work Sans', sans-serif",
            color: "#444",
          }}
        >
          <CheckCircleIcon color="primary" /> License & Access
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontFamily: "'Work Sans', sans-serif",
            color: "#555",
            marginTop: "8px",
            lineHeight: 1.7,
          }}
        >
          Stok101 grants you a limited, non-exclusive license to use our services for personal
          or internal business purposes only. Unauthorized redistribution, modification, or
          commercial use of our data or tools is strictly prohibited.
        </Typography>
      </Box>

      {/* Section 2: Data Ownership */}
      <Box sx={{ marginBottom: "24px" }}>
        <Typography
          variant="h6"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            fontWeight: "bold",
            fontFamily: "'Work Sans', sans-serif",
            color: "#444",
          }}
        >
          <WarningIcon color="error" /> Data Ownership & Derivation
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontFamily: "'Work Sans', sans-serif",
            color: "#555",
            marginTop: "8px",
            lineHeight: 1.7,
          }}
        >
          All data, insights, and tools provided by Stok101 are proprietary and are derived
          using our proprietary algorithms. Derived market data is displayed only to
          non-professional clients and cannot be reverse-engineered. Raw market data is not
          accessible to clients under any circumstances.
        </Typography>
      </Box>

      {/* Section 3: Security */}
      <Box sx={{ marginBottom: "24px" }}>
        <Typography
          variant="h6"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            fontWeight: "bold",
            fontFamily: "'Work Sans', sans-serif",
            color: "#444",
          }}
        >
          <InfoIcon color="info" /> Account Security
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontFamily: "'Work Sans', sans-serif",
            color: "#555",
            marginTop: "8px",
            lineHeight: 1.7,
          }}
        >
          You are responsible for the confidentiality of your account credentials and for all
          activities under your account. If you suspect unauthorized use, please notify us
          immediately at{" "}
          <Link
            href="mailto:support@stok101.com"
            sx={{ color: "#007bfc", fontWeight: "bold", textDecoration: "none" }}
          >
            support@stok101.com
          </Link>
          .
        </Typography>
      </Box>

      {/* Section 4: Payments & Subscriptions */}
      <Box sx={{ marginBottom: "24px" }}>
        <Typography
          variant="h6"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            fontWeight: "bold",
            fontFamily: "'Work Sans', sans-serif",
            color: "#444",
          }}
        >
          <CheckCircleIcon color="primary" /> Payments & Cancellation
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontFamily: "'Work Sans', sans-serif",
            color: "#555",
            marginTop: "8px",
            lineHeight: 1.7,
          }}
        >
          Subscriptions are billed monthly or annually in advance. Plans will auto-renew unless cancelled. Refunds are
          available for annual plans requested within 14 days of payment, excluding upgrades or
          purchases made with crypto. Full details can be found on the billing page of your
          account.
        </Typography>
      </Box>

      {/* Section 5: Investment Disclaimer */}
      <Box sx={{ marginBottom: "24px" }}>
        <Typography
          variant="h6"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            fontWeight: "bold",
            fontFamily: "'Work Sans', sans-serif",
            color: "#444",
          }}
        >
          <WarningIcon color="error" /> Investment Disclaimer
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontFamily: "'Work Sans', sans-serif",
            color: "#555",
            marginTop: "8px",
            lineHeight: 1.7,
          }}
        >
          Investments involve risks, including potential loss of principal. Stok101 does not
          provide financial or legal advice. The tools and data provided are for educational
          purposes and should not be interpreted as recommendations.
        </Typography>
      </Box>

      {/* Section 6: Contact */}
      <Box>
        <Typography
          variant="h6"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            fontWeight: "bold",
            fontFamily: "'Work Sans', sans-serif",
            color: "#444",
          }}
        >
          <InfoIcon color="info" /> Contact Us
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontFamily: "'Work Sans', sans-serif",
            color: "#555",
            marginTop: "8px",
            lineHeight: 1.7,
          }}
        >
          Need assistance? Reach us at{" "}
          <Link
            href="mailto:support@stok101.com"
            sx={{ color: "#007bfc", fontWeight: "bold", textDecoration: "none" }}
          >
            support@stok101.com
          </Link>
          .
        </Typography>
      </Box>
    </Box>
    </Box>
  );
};

export default TermsAndPolicies;
